import { IconButton, Menu, MenuItem } from "@mui/material";
import React from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const MenuDetalhe = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const elementos = props.itens
    ? props.itens.filter((elem) => elem.visible !== false)
    : [];
  return (
    <React.Fragment>
      <IconButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        size="large"
      >
        <MoreHorizIcon fontSize="small" />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {elementos.map((item, i) => (
          <MenuItem
            key={i}
            onClick={() => {
              handleClose();
              item.call();
            }}
          >
            {item.nome}
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
};

export default MenuDetalhe;
